import { FeatureRequest } from "interfaces/feature-request";
import React from "react";
import styled from "styled-components";
import styles from "styles/styles";

interface FeatureRequestDetailsProps {
    featureRequest: FeatureRequest;
}

const Container = styled.div`
    display: flex;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
`;

const TimelineContainer = styled.div`
    background-color: ${styles.colors.lightGrey};
    flex: 1;
    padding: 1.5rem;
`;

const TimelineDetails = styled.div`
    background-color: ${styles.colors.grey3};
    padding: 1.5rem;
    flex-shrink: 0;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.5rem 1rem;
`;

const ProgressBarContainer = styled.div`
    width: 100%;
    height: 20px;
    background-color: ${styles.colors.grey4};
    border-radius: 5px;
    overflow: hidden;
    margin: 0 0 1rem 0;
`;

const getProgressColor = (percentage: number) => {
    if (percentage <= 25) {
        return styles.colors.red;
    } else if (percentage <= 50) {
        return styles.colors.darkRed;
    } else if (percentage <= 75) {
        return styles.colors.grey5;
    } else {
        return styles.colors.green5;
    }
};

const ProgressBarFill = styled.div<{ percentage: number }>`
    height: 100%;
    width: ${(props) => props.percentage}%;
    background-color: ${(props) => getProgressColor(props.percentage)};
    transition: width 0.3s ease-in-out, background-color 0.3s ease-in-out;
`;

const ProgressLabels = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 0.5rem;
`;

const ProgressBarHeader = styled.p`
    font-weight: 400;
    font-size: 16px;
    margin: 1rem 0 0.25rem 0;
`;

const calculateReadyPercentage = (featureRequest: FeatureRequest): number => {
    if (featureRequest.state === "Ratkaistu" || featureRequest.state === "Hylätty") {
        return 100;
    } else if (featureRequest.state === "Suositeltu") {
        return 75;
    } else if (featureRequest.state === "Käsittelyssä") {
        return 50;
    } else if (featureRequest.state === "Uusi") {
        return 25;
    } else {
        return 0;
    }
};

const DetailsTimeline: React.FC<FeatureRequestDetailsProps> = ({ featureRequest }) => (
    <Container>
        <TimelineContainer>
            <ProgressLabels>
                <span>Toiminnallinen alue: {featureRequest.businessArea}</span>
                <span>Kokoluokka-arvio: -</span>
                <span>Toimialavaikutus: -</span>
                <span>Prioriteetti: -</span>
            </ProgressLabels>
            <ProgressBarHeader>Vaihe</ProgressBarHeader>
            <ProgressBarContainer>
                <ProgressBarFill percentage={calculateReadyPercentage(featureRequest)} />
            </ProgressBarContainer>
            <ProgressLabels>
                <span>Uudet kehitysehdotukset</span>
                <span>Tulossa käsittelyyn</span>
                <span>Alustava hyväksyntä</span>
                <span>Hyväksytty, kehitysjonossa</span>
            </ProgressLabels>
        </TimelineContainer>
        <TimelineDetails>
            <span>Luotu:</span>
            <span>{featureRequest.createdAt}</span>

            <span>Käsitelty:</span>
            <span>-</span>

            <span>Hyväksytty:</span>
            <span>-</span>

            <span>Toteutus:</span>
            <span>-</span>
        </TimelineDetails>
    </Container>
);

export default DetailsTimeline;
